module.exports = __webpack_public_path__ + "static/media/neo-logo.7fc06614.png";